import React from 'react'
import { ProductCardWrapperProps } from './types'
import './index.scss'
import { EcomProductCard } from '@petz/ecom-product-card'

export const ProductCardWrapper: React.FC<ProductCardWrapperProps> = ({ size, data, skeleton = false }) => {
  return (
    <div className={`product-card-wrapper ${skeleton ? 'skeleton' : ''}`}>
      <EcomProductCard
        size={size}
        data={data}
        // TODO: build error
        // onAddToBag={() => console.log('addToBag')}
        // onClickCombo={() => console.log('clickCombo')}
        // onNotifyMe={() => console.log('notifyMe')}
        // onToggleFavorite={() => true}
      />
    </div>
  )
}
